"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _isNil = _interopRequireDefault(require("../utils/isNil"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _useFormState2 = _interopRequireDefault(require("../hooks/useFormState"));

var _excluded = ["allowNegative", "thousandSeparator", "decimalScale", "prefix", "suffix"];

/**
 * Base number format used for other number formats.
 */
var NumberFormat = function NumberFormat(_ref) {
  var allowNegative = _ref.allowNegative,
      thousandSeparator = _ref.thousandSeparator,
      decimalScale = _ref.decimalScale,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useFormState = (0, _useFormState2["default"])(props),
      onBlur = _useFormState.onBlur,
      name = _useFormState.name,
      onChange = _useFormState.onChange,
      helperText = _useFormState.helperText,
      value = _useFormState.value,
      error = _useFormState.error;

  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat["default"], (0, _extends2["default"])({}, props, {
    onChange: _noop["default"],
    onBlur: onBlur,
    name: name,
    helperText: helperText,
    value: value,
    error: error,
    withoutState: true,
    customInput: _TextField["default"],
    onValueChange: function onValueChange(_ref2, event) {
      var floatValue = _ref2.floatValue;
      onChange && onChange(event, (0, _isNil["default"])(floatValue) ? null : floatValue);
    },
    allowNegative: allowNegative,
    thousandSeparator: thousandSeparator,
    decimalScale: decimalScale,
    prefix: prefix,
    suffix: suffix
  }));
};

NumberFormat.propTypes = {
  allowNegative: _propTypes["default"].bool,
  thousandSeparator: _propTypes["default"].bool,
  decimalScale: _propTypes["default"].number,
  prefix: _propTypes["default"].string,
  suffix: _propTypes["default"].string,
  onChange: _propTypes["default"].func
};
NumberFormat.defaultProps = {
  prefix: '',
  suffix: '',
  allowNegative: false,
  decimalScale: 2
};
var _default = NumberFormat;
exports["default"] = _default;